{
	"backToManageDeclarations": "Tillbaka till Hantera deklarationer"
}
